// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.

import { useEffect, useRef, useState } from "react";
import { getTableauTicket } from "../services/auth.service";
import { TableauEventType, TableauViz, Toolbar } from "@tableau/embedding-api";
import { logAmplitudeEvent } from "../utils/amplitude/functions";
import amplitude from "../utils/amplitude/initiate";


const TableauDashboardPOC = () => {
    const [dashboardLoading, setDashboardLoading] = useState(true);
    const [iframeLoading, setIframeLoading] = useState(true);

    const vizContainerRef = useRef(null);
    const currentViz = useRef(null);

    const activedashboard = {
        url: "https://hwaibit.analytics-hub.com/#/site/Aetna/views/MarketSnapshotV2/MarketSnapshot",
    };

    const addTableauEventListeners = (viz) => {
        if (typeof window === "undefined") return;

        viz.addEventListener(TableauEventType.CustomViewLoaded, () => {
            console.log("CustomViewLoaded event fired");
        });

        viz.addEventListener(TableauEventType.CustomViewRemoved, () => {
            console.log("CustomViewRemoved event fired");
        });

        viz.addEventListener(TableauEventType.CustomViewSaved, () => {
            console.log("CustomViewSaved event fired");
        });

        viz.addEventListener(TableauEventType.CustomViewSetDefault, () => {
            console.log("CustomViewSetDefault event fired");
        });

        viz.addEventListener(TableauEventType.EditButtonClicked, () => {
            console.log("EditButtonClicked event fired");
        });

        viz.addEventListener(TableauEventType.EditInDesktopButtonClicked, () => {
            console.log("EditInDesktopButtonClicked event fired");
        });

        viz.addEventListener(TableauEventType.FilterChanged, (e) => {
            console.log("FilterChanged event fired", e);
        });

        viz.addEventListener(TableauEventType.FirstVizSizeKnown, (e) => {
            console.log("FirstVizSizeKnown event fired", e);
            // window.querySelector("#tableauVizID").style.height = "100%";
            // window.querySelector("#tableauVizID").style.width = "100%";
        });

        viz.addEventListener(TableauEventType.FirstInteractive, async (e) => {
            console.log("FirstInteractive event fired", e);

            // const sheet = viz.workbook.activeSheet;

            // viz.workbook.getParametersAsync().then((params) => {
            //     console.log(params.map((param) => param.name));
            // });

            // console.log(sheet.worksheets?.map((ws) => ws.name));
        });

        viz.addEventListener(TableauEventType.CustomMarkContextMenuEvent, () => {
            console.log("CustomMarkContextMenuEvent event fired");
        });

        viz.addEventListener(TableauEventType.MarkSelectionChanged, (e) => {
            console.log("MarkSelectionChanged event fired", e);
            const sheet = viz.workbook.activeSheet;
            sheet.getFiltersAsync().then((filters) => {
                console.log("Filters in active worksheet - Execute");
                console.log(filters.filter((filter) => filter.worksheetName === "Execute").map((filter) => [filter.fieldName, filter]));
            });
            console.log("Workbook");
            console.log(viz.workbook);
            viz.workbook.getParametersAsync().then((params) => {
                console.log("Parameters in workbook");
                console.log(params.map((param) => [param.name, param]));
            });
            console.log("Sheets");
            console.log((sheet).worksheets.map((sheet) => sheet.name));
            
        });

        viz.addEventListener(TableauEventType.ParameterChanged, () => {
            console.log("ParameterChanged event fired");
        });

        viz.addEventListener(TableauEventType.ToolbarStateChanged, (e) => {
            console.log("ToolbarStateChanged event fired", e);
        });

        viz.addEventListener(TableauEventType.UrlAction, () => {
            console.log("UrlAction event fired");
        });

        viz.addEventListener(TableauEventType.TabSwitched, () => {
            console.log("TabSwitched event fired");
        });

        viz.addEventListener(TableauEventType.StoryPointSwitched, () => {
            console.log("StoryPointSwitched event fired");
        });

        viz.addEventListener(TableauEventType.IframeSrcUpdated, () => {
            console.log("IframeSrcUpdated event fired");
        });
    };

    const initializeViz = (container, dashboardUrl) => {
        container.innerHTML = "";
        const viz = new TableauViz();
        viz.src = dashboardUrl;
        viz.toolbar = Toolbar.Top;
        viz.style.width = "100%";
        viz.style.height = "100%";
        viz.style.overflow = "hidden";
        viz.id = "tableauVizID";
        viz.iframeAttributeLoading = "lazy";

        // viz.iframe.shadowRoot.querySelector("iframe").setAttribute("loading", "lazy");

        addTableauEventListeners(viz);
        container.appendChild(viz);
    };

    async function createTableaUUrl(activedashboard, container) {

        try {
            if (!activedashboard?.url) {
                return;
            }

            const splittedUrl = activedashboard?.url?.split("/");

            let tempUrl = activedashboard?.url;

            if (
                splittedUrl[2]?.trim() === "hwaibit.analytics-hub.com" &&
                splittedUrl[3]?.trim() === "#"
            ) {
                let tabtoken = await getTableauTicket(
                    splittedUrl[5],
                    activedashboard?.accesstype ?? null
                );
                const toolbarParam =
                    activedashboard?.accesstype === "authoring" ? "no" : "yes";
                tempUrl =
                    `${process.env.REACT_APP_TAB_SERVER}` +
                    "/trusted/" +
                    tabtoken +
                    "/t/" +
                    splittedUrl[5] +
                    "/views/" +
                    splittedUrl[7] +
                    "/" +
                    splittedUrl[8] +
                    `?:embed=yes&:toolbar=${toolbarParam}`;
            } else if (
                splittedUrl[2]?.trim() === "hwaibit.analytics-hub.com" &&
                splittedUrl[3]?.trim() === "t"
            ) {
                let tableauToken = await getTableauTicket(
                    splittedUrl[4],
                    activedashboard?.accesstype ?? null
                );
                // replacing views with authoring
                const toolbarParam =
                    activedashboard?.accesstype === "authoring" ? "no" : "yes";
                tempUrl =
                    `${process.env.REACT_APP_TAB_SERVER}` +
                    "/trusted/" +
                    tableauToken +
                    "/t/" +
                    splittedUrl[4] +
                    "/views/" +
                    splittedUrl[6] +
                    "/" +
                    splittedUrl[7] +
                    `?:embed=yes&:toolbar=${toolbarParam}`;
            }

            initializeViz(container, tempUrl);

        } catch (err) {
            console.log(err, "error in creating tableau url");
        }
    }

    useEffect(() => {
        // setIframeLoading(true);
        const container = vizContainerRef.current;
        if (container) {
            createTableaUUrl(activedashboard, container);
        }

        return () => {
            if (container) {
                container.innerHTML = "";
            }
        };
    }, []);

    // useResizeObserver(vizContainerRef, () => {
    //     if (vizContainerRef.current) {
    //         // currentViz.current;
    //         // setIframeLoading(true);
    //         // vizContainerRef.current.innerHTML = "";
    //         createTableaUUrl(activedashboard, vizContainerRef.current);

    //     }
    // });

    return (
        <>
            {/* {(iframeLoading) && (
                <div className="overflow-y-hidden">
                    <div className={`absolute left-[40px] z-[20] ${false ? 'top-[81px]' : 'top-[56px]'} right-0  bottom-[35px] overflow-y-hidden `}>
                        <FullScreenLoader />
                    </div>
                </div>
            )} */}

            <div ref={vizContainerRef} id={"tableauViz"} className="overflow-hidden w-full h-full bottom-10" />

            {/* <TableauDashboard dashboardUrl={url} dashboardId={activedashboard?._id ?? "tableauVizID"} onLoad={() => { setIframeLoading(false) }} /> */}
        </>
    );
};
export default TableauDashboardPOC;
